/* eslint-disable no-redeclare */
import { z } from 'zod';

import { UUID } from '../primitive';
import { AdServer, FeaturedAd } from './feature-ad';

export const FeaturedAds = z.object({
  id: UUID,
  adsSource: AdServer.optional(),
  searchMethod: z.string().optional(),
  segmentationFit: z.string().optional(),
  result: z.array(FeaturedAd),
});

export type FeaturedAds = z.infer<typeof FeaturedAds>;
